import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MenuPrincipalComponent } from '../shared/menu-principal/menu-principal.component';
import { GestionMaterialesComponent } from '../components/materiales/gestion-materiales/gestion-materiales.component';
import { HomePrincipalComponent } from '../components/home-principal/home-principal.component';
import { NuevoUsuarioComponent } from '../components/admin-usuario/nuevo-usuario/nuevo-usuario.component';
import { AsignarPerfilComponent } from '../components/admin-usuario/asignar-perfil/asignar-perfil.component';
import { CargaActualizacionBdComponent } from '../components/admin-configuracion/carga-actualizacion-bd/carga-actualizacion-bd.component';
import { ReseteoMacComponent } from '../components/admin-configuracion/reseteo-mac/reseteo-mac.component';
import { GestionMatCompuestosComponent } from '../components/materiales/gestion-mat-compuestos/gestion-mat-compuestos.component';
import { GestionEquiposComponent } from '../components/equipos/gestion-equipos/gestion-equipos.component';
import { GestionEquiposCompuestosComponent } from '../components/equipos/gestion-equipos-compuestos/gestion-equipos-compuestos.component';
import { GestionManoDeObraComponent } from '../components/mano-de-obra/gestion-mano-de-obra/gestion-mano-de-obra.component';
import { GestionManoObraCompuestaComponent } from '../components/mano-de-obra/gestion-mano-obra-compuesta/gestion-mano-obra-compuesta.component';
import { PartidasComponent } from '../components/partidas/gestion-partidas/partidas.component';
import { PerfilUsuarioComponent } from '../components/perfil-usuario/perfil-usuario.component';
import { CambioClaveComponent } from '../components/cambio-clave/cambio-clave.component';
import { CambiarFechaBdComponent } from '../components/admin-configuracion/cambiar-fecha-bd/cambiar-fecha-bd.component';
import { ListaUsuariosComponent } from '../components/admin-usuario/lista-usuarios/lista-usuarios.component';
import { AuthGuard } from '../shared/auth-guard';
import { PresupuestosComponent } from '../components/presupuestos/gestion-presupuestos/presupuestos.component';
import { NuevoPresupuestoComponent } from '../components/presupuestos/nuevo-presupuesto/nuevo-presupuesto.component';
import { DetallePresupuestoComponent } from '../components/presupuestos/detalle-presupuesto/detalle-presupuesto.component';
import { CargaActualizacionCapitulosComponent } from '../components/presupuestos/admin-configuracion/carga-actualizacion-capitulos/carga-actualizacion-capitulos.component';

const routes: Routes = [
  {
    path: 'menu',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: '', component: MenuPrincipalComponent,
    children: [
      {
        path: 'home',
        pathMatch: 'prefix',
        component: HomePrincipalComponent,
        canActivate: [AuthGuard]
      },
      { path: 'materiales',
        pathMatch: 'prefix',
        component: GestionMaterialesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'nuevoUsuario',
        pathMatch: 'prefix',
        component: NuevoUsuarioComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cambiarPerfil',
        pathMatch: 'prefix',
        component: AsignarPerfilComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'actualizarBd',
        pathMatch: 'prefix',
        component: CargaActualizacionBdComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'actualizarMac',
        pathMatch: 'prefix',
        component: ReseteoMacComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'matCompuestos',
        pathMatch: 'prefix',
        component: GestionMatCompuestosComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'equipos',
        pathMatch: 'prefix',
        component: GestionEquiposComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'equiposCompuestos',
        pathMatch: 'prefix',
        component: GestionEquiposCompuestosComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manoDeObra',
        pathMatch: 'prefix',
        component: GestionManoDeObraComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manoDeObraCompuesta',
        pathMatch: 'prefix',
        component: GestionManoObraCompuestaComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'partidas/:id',
        pathMatch: 'prefix',
        component: PartidasComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'infoUser',
        pathMatch: 'prefix',
        component: PerfilUsuarioComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cambioClaveUser',
        pathMatch: 'prefix',
        component: CambioClaveComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cambioFechaBd',
        pathMatch: 'prefix',
        component: CambiarFechaBdComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'listaUsuarios',
        pathMatch: 'prefix',
        component: ListaUsuariosComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'presupuestos',
        pathMatch: 'prefix',
        component: PresupuestosComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'nuevoPresupuesto',
        pathMatch: 'prefix',
        component: NuevoPresupuestoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'infoPresupuesto',
        pathMatch: 'prefix',
        component: DetallePresupuestoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'actualizarBdCapitulos',
        pathMatch: 'prefix',
        component: CargaActualizacionCapitulosComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', useHash: true })
  ],
  exports: [
    RouterModule
  ],
  declarations: [],
  providers: [AuthGuard],
})
export class RoutesModule { }
